import { defineComponent as _, useAttrs as I, useSlots as O, computed as t, createBlock as c, openBlock as l, resolveDynamicComponent as T, mergeProps as R, unref as d, withCtx as b, createCommentVNode as m, renderSlot as w, createElementBlock as o, createTextVNode as k, toDisplayString as r } from "vue";
import n from "lodash-es/uniqueId";
import { _ as q } from "./Label.vue_vue_type_script_setup_true_lang-CNquF3AP.js";
const S = ["id"], D = {
  key: 2,
  class: "stash-field-hint tw-mt-1 tw-block tw-whitespace-pre-line tw-text-xs",
  "data-test": "stash-field-hint"
}, E = {
  key: 3,
  class: "stash-field-hint tw-mt-1 tw-whitespace-pre-line tw-text-xs",
  "data-test": "stash-field-hint"
}, C = /* @__PURE__ */ _({
  inheritAttrs: !1,
  __name: "Field",
  props: {
    addBottomSpace: { type: Boolean, default: !1 },
    errorText: { default: void 0 },
    hintText: { default: void 0 },
    id: { default: void 0 },
    errorId: { default: void 0 },
    isReadOnly: { type: Boolean },
    isRequired: { type: Boolean, default: !1 },
    label: { default: void 0 },
    showOptionalInLabel: { type: Boolean, default: !1 },
    isLabelSrOnly: { type: Boolean, default: !1 },
    fieldset: { type: Boolean, default: !1 },
    isDisabled: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 }
  },
  setup(y) {
    const e = y, v = I(), a = O(), f = t(() => e.id || n("stash-field-")), h = t(() => e.errorId || n("stash-field-error-")), u = t(() => n("stash-field-label-")), i = t(() => !!e.errorText), x = t(() => e.fieldset ? "fieldset" : "div"), B = t(() => {
      const { placeholder: s, ...p } = v;
      return p;
    });
    return (s, p) => (l(), c(T(x.value), R({
      "data-test": "stash-field",
      class: ["stash-field", [
        { "tw-p-0": e.fieldset },
        { "tw-mb-9": e.addBottomSpace && !e.errorText && !e.hintText && !d(a).hint },
        { "tw-mb-4": e.addBottomSpace && (e.errorText || e.hintText || d(a).hint) },
        { "stash-field--disabled": e.isDisabled || e.disabled },
        { "stash-field--is-read-only": e.isReadOnly },
        { "stash-field--is-required": e.isRequired },
        { "stash-field--has-error": i.value }
      ]]
    }, B.value), {
      default: b(() => [
        e.label ? (l(), c(q, {
          key: 0,
          id: u.value,
          for: f.value,
          "has-error": i.value,
          "is-required": s.isRequired,
          "show-optional": e.showOptionalInLabel,
          "is-sr-only": e.isLabelSrOnly,
          legend: e.fieldset,
          disabled: e.isDisabled || e.disabled
        }, {
          default: b(() => [
            k(r(e.label), 1)
          ]),
          _: 1
        }, 8, ["id", "for", "has-error", "is-required", "show-optional", "is-sr-only", "legend", "disabled"])) : m("", !0),
        w(s.$slots, "default", {
          fieldId: f.value,
          fieldErrorId: h.value,
          hasError: i.value,
          isRequired: s.isRequired,
          isReadOnly: e.isReadOnly,
          disabled: e.isDisabled || e.disabled,
          labelId: u.value,
          showOptionalInLabel: e.showOptionalInLabel
        }),
        e.errorText ? (l(), o("span", {
          key: 1,
          id: h.value,
          class: "stash-field-error tw-mt-1 tw-block tw-whitespace-pre-line tw-text-xs tw-text-red-500",
          "data-test": "stash-field-error"
        }, r(e.errorText), 9, S)) : e.hintText && !e.isReadOnly ? (l(), o("span", D, r(e.hintText), 1)) : d(a).hint && !e.isReadOnly ? (l(), o("div", E, [
          w(s.$slots, "hint")
        ])) : m("", !0)
      ]),
      _: 3
    }, 16, ["class"]));
  }
});
export {
  C as _
};
//# sourceMappingURL=Field.vue_vue_type_script_setup_true_lang-DI6z3AE9.js.map
